import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import { Icon } from '@mgc/react-components';
import MapPropTypes from '../../MapPropTypes';
import selectors from '../../../selectors';
import UiActions from '../../../actions/ui';
import OrderActions from '../../../actions/order';
import ModalBase from '../Base';
import strings from '../../../strings';
import utils from '../../../utils';
import TransactionHistory from './TransactionHistory';
import OrderCancelModal from './OrderCancelModal';

import './TransactionModal.scss';

class TransactionModal extends Component {
    static propTypes = {
        close: PropTypes.func.isRequired,
        offer: MapPropTypes.OfferProps,
        transactions: PropTypes.arrayOf(MapPropTypes.TransactionProps),
        lastTransaction: MapPropTypes.TransactionProps,
        selectedTransaction: MapPropTypes.TransactionProps,
        visible: PropTypes.bool.isRequired,
        downloadTransactionReport: PropTypes.func.isRequired,
    };

    static mapState = (state) =>
        mapSelectors(state, {
            offer: selectors.offer.getSelectedOffer,
            visible: selectors.ui.getTransactionModalVisible,
            cancelVisible: selectors.ui.getOrderCancelModalVisible,
            lastTransaction: selectors.offer.getLastTransaction,
            selectedTransaction: selectors.order.getSelectedTransaction,
            transactions: selectors.offer.getSortedTransactions,
        });

    static mapDispatch = (dispatch) => ({
        close: () => dispatch(UiActions.closeModal('transaction')),
        selectTransaction: (transaction) =>
            dispatch(OrderActions.selectTransaction(transaction)),
        closeCancel: () => dispatch(UiActions.closeModal('cancel')),
        cancelOrder: (transaction, history) =>
            dispatch(OrderActions.cancelOrder(transaction, history)),
        openCancelModal: () => dispatch(UiActions.openModal('cancel')),
        downloadTransactionReport: (offer) =>
            dispatch(OrderActions.downloadTransactionReport(offer)),
    });

    _renderAvailableCredits() {
        if (!this.props.offer) {
            return <span />;
        }

        return (
            <div>
                <div className="display-3 text-info text-center">
                    <b>{utils.formatPrice(this.props.offer.balance)}</b>
                </div>
                <div className="text-uppercase text-xs text-mute text-center">
                    {strings.availableCredits}
                </div>
                <div className="text-center text-xs text-muted m-t-xs">
                    {strings.contractDuration}:{' '}
                    {utils.formatShortDate(this.props.offer.validFrom)} -{' '}
                    {utils.formatShortDate(this.props.offer.validTo)}
                </div>
            </div>
        );
    }

    _renderLastTransaction() {
        if (!this.props.lastTransaction) {
            return <div />;
        }

        return (
            <div>
                <dl className="dl-horizontal border-top text-sm m-b-0 m-t p-t-sm">
                    <dt className="col-xs-6 text-right">
                        {strings.lastTransaction}
                    </dt>
                    <dd className="col-xs-6">
                        {utils.formatDate(
                            this.props.lastTransaction.lastModified
                        )}
                    </dd>
                    <dt className="col-xs-6 text-right">
                        {strings.creditsUsed}
                    </dt>
                    <dd
                        className={`col-xs-6 ${utils.amountClass(
                            this.props.lastTransaction
                        )}`}
                    >
                        {utils.formatPrice(this.props.lastTransaction.amount)}
                    </dd>
                    <dt className="col-xs-6 text-right">{strings.currency}</dt>
                    <dd className="col-xs-6">
                        {this.props.lastTransaction.currencey || 'USD'}
                    </dd>
                </dl>
                <div className="text-center border-bottom p-b-sm m-b-md wide-border">
                    <button
                        className="btn btn-info btn-sm"
                        onClick={() =>
                            this.props.downloadTransactionReport(
                                this.props.offer
                            )
                        }
                    >
                        <Icon name="icon-download2" />{' '}
                        {strings.downloadTransactions}
                    </button>
                </div>
            </div>
        );
    }

    render() {
        return (
            <ModalBase
                modalClassName="transaction-modal"
                modalTitle={strings.transactions}
                visible={this.props.visible}
                closeModal={this.props.close}
            >
                {this._renderAvailableCredits()}
                {this._renderLastTransaction()}
                <TransactionHistory
                    transactions={this.props.transactions}
                    cancelOrder={(t) => {
                        this.props.selectTransaction(t);
                        this.props.openCancelModal();
                    }}
                    downloadTransactionReport={() =>
                        this.props.downloadTransactionReport()
                    }
                />
                <OrderCancelModal
                    visible={this.props.cancelVisible}
                    close={() => this.props.closeCancel()}
                    transaction={this.props.selectedTransaction}
                    cancelOrder={(t) =>
                        this.props.cancelOrder(t, this.props.history)
                    }
                />
            </ModalBase>
        );
    }
}

export default withRouter(attach(TransactionModal));



// WEBPACK FOOTER //
// ./app/components/Modals/TransactionModal/index.jsx